import { render, staticRenderFns } from "./ShenPiFeiYong.vue?vue&type=template&id=2d8ceb54&scoped=true&"
import script from "./ShenPiFeiYong.vue?vue&type=script&lang=js&"
export * from "./ShenPiFeiYong.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiFeiYong.vue?vue&type=style&index=0&id=2d8ceb54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ceb54",
  null
  
)

export default component.exports